import { Button, FullModal } from '@sbt-web/ui';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { STEP_CONFIGURATION } from '../configuration';
import { trackClick, trackView } from '../tracking';
import type { StepID } from '../types';
import { storeDismiss } from '../helpers';
import styles from './index.module.scss';

type Props = {
  open: boolean;
  onClose: () => void;
};

const VerifiedUserFakeDoorDialog = ({ open, onClose }: Props) => {
  const [step, setStep] = useState<StepID | undefined>();
  const config = step ? STEP_CONFIGURATION.get(step) : null;

  // reset the step to the first one
  useEffect(() => {
    if (open) {
      setStep('awareness');
    } else {
      setStep(undefined);
    }
  }, [open]);

  // track view event of the visible step
  useEffect(() => {
    if (open && step) {
      trackView(step);
    }
  }, [open, step]);

  const actions = (
    <>
      {config?.rejectAction ? (
        <Button
          design={'text'}
          classes={[styles['cta'], styles['cta--reject']]}
          onClick={() => {
            // show the thankyou page also if the user rejects the "purchase" step
            if (step === 'purchase') {
              setStep('typ');
            } else {
              onClose();
            }

            // track click
            if (config.rejectAction)
              trackClick(
                config.rejectAction.objectID,
                config.rejectAction.label
              );
          }}
        >
          {config.rejectAction.label}
        </Button>
      ) : null}
      {config ? (
        <Button
          classes={[styles['cta']]}
          onClick={() => {
            // dismiss the fake door
            if (config.next === 'typ') {
              storeDismiss();
            }

            // go ahead or close the modal
            if (config.next) {
              setStep(config.next);
            } else {
              onClose();
            }
            // track click
            trackClick(config.nextAction.objectID, config.nextAction.label);
          }}
        >
          {config.nextAction.label}
        </Button>
      ) : null}
    </>
  );

  return (
    <FullModal
      size={'small'}
      title={'Profilo verificato'}
      open={open}
      onClose={() => {
        if (step && step !== 'typ') {
          trackClick(`${step}_dismiss`, 'Chiudi il dialogo');
        }
        onClose();
      }}
      actions={actions}
    >
      <Step title={config?.title ?? ''} illustration={config?.illustration}>
        {config?.description}
      </Step>
    </FullModal>
  );
};

const Step = ({
  title,
  illustration,
  children,
}: {
  title: string;
  illustration?: string;
} & PropsWithChildren) => {
  return (
    <div className={styles['content']}>
      {illustration ? (
        <img
          className={styles['image']}
          alt=""
          height="180"
          width="240"
          decoding="async"
          src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/illustrations/${illustration}`}
        />
      ) : null}
      <h4 className={`headline-6 ${styles['title']}`}>{title}</h4>
      <div className={`body-text small ${styles['description']}`}>
        {children}
      </div>
    </div>
  );
};

export default VerifiedUserFakeDoorDialog;
